<template>
    <div 
        class="footer-nav"
        :class="iphonex&&'ios'"
    >
        <div @click="go('/hotel/home')">
            <div>
               <img 
                    src="@/assets/hotel/img/micon/home.png" 
                    alt="home"
                    v-if="active!='home'"
                >
                <img 
                    src="@/assets/hotel/img/micon/home_active.png" 
                    alt="home"
                    v-if="active=='home'"
                > 
            </div>
            <p>小巴酒店</p>
        </div>
        <div @click="go('/hotel/myOrder')">
            <div>
                <img 
                    src="@/assets/hotel/img/micon/order.png" 
                    alt="myOrder"
                    v-if="active!='myOrder'"
                >
                <img 
                    src="@/assets/hotel/img/micon/order_active.png" 
                    alt="myOrder"
                    v-if="active=='myOrder'"
                >
            </div>
            <p>我的订单</p>
        </div>
        <div @click="go('/hotel/collection')">
            <div>
               <img 
                    src="@/assets/hotel/img/micon/collection.png" 
                    alt="collection"
                    v-if="active!='collection'"
                >
                <img 
                    src="@/assets/hotel/img/micon/collection_active.png" 
                    alt="collection"
                    v-if="active=='collection'"
                > 
            </div>
            <p>我的收藏</p>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            active:{type:String,required:true,default:'home'},//标识要选中那个
        },
        data() {
            return {
                iphonex:false,//是不是iphonex
            }
        },
        mounted() {
            setTimeout(()=>{
                if(sessionStorage.isiOSX){
                    this.iphonex = JSON.parse(sessionStorage.isiOSX);
                }
            },100)
        },
        methods: {
            go(path){//跳转
            console.log('菜单跳转')
                this.$router.push(path);
            }
        },
    }
</script>

<style lang="less" scope>
    .footer-nav{
        display: flex;
        justify-content: space-around;
        padding-top: 0.3rem;
        padding-bottom: 0.4rem;
        background-color: #fff;
        >div{
            text-align: center;
            flex: 1;
            >div{
                height: 2.1rem;
            }
            img{
                vertical-align: top;
            }
            &:nth-of-type(1){
                img{
                    width: 1.8rem;
                    height: 2rem;
                }
            }
            &:nth-of-type(2){
                img{
                    width: 1.5rem;
                    height: 2.1rem;
                }
            }
            &:nth-of-type(3){
                img{
                    width: 2.1rem;
                    height: 2rem;
                }
            }
            p{
                font-size: 1.1rem;
                line-height: 1.6rem;
                font-weight: 400;
                color: #999999;
                &.active{
                    font-weight: 500;
                    color: #0C0D0E;
                }
            }
        }
        &.ios{
            padding-bottom: 3.8rem;
        }
    }
</style>